import SobreNosotros from '../../components/SobreNosotros/SobreNosotros.jsx'

export default function SobreNosotrosPage() {
  return (
    <>
      
      <SobreNosotros />
    </>
  );
}
